// 查看会员信息 （客户交易记录）
<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
      <div>
        <el-card class="NumberCardWidth">
          <div class="deal flex-between">
            <div class="card-text">
              <h3>产品详细信息</h3>
            </div>
            <div class="card-button">
              <el-button class="push-button" @click="NvagetToLookMenber" icon="iconfont icon-fanhui">返回</el-button>
            </div>
          </div>
          <div class="NumberTable">
            <el-form label-width="140px" :model="queryInfo" size="small">
              <el-row type="flex" class="row-bg">
                <el-col :span="12">
                  <el-form-item label="SKU">
                    <el-input v-model="queryInfo.sku" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="SKU描述中文">
                    <el-input v-model="queryInfo.skudesc_CN" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="SKU描述英文">
                    <el-input v-model="queryInfo.skudesc_EN" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="SKU描述意大利">
                    <el-input v-model="queryInfo.skudesc_IT" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="品牌编号">
                    <el-input v-model="queryInfo.brandNo" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="种类编号">
                    <el-input v-model="queryInfo.familyID" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="类别">
                    <el-input v-model="queryInfo.category_cn" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="类别英文">
                    <el-input v-model="queryInfo.category_en" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="产品线编号">
                    <el-input v-model="queryInfo.lineID" disabled style="width: 80%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <el-image style="width: 80%; height: 17.5rem" :src="queryInfo.imgFileName1">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i></div
                    ></el-image>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="成份"> <el-input v-model="queryInfo.composition_cn" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="成份英文"> <el-input v-model="queryInfo.composition_en" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="尺码模板编号">
                    <el-input v-model="queryInfo.sizeTemplateID" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="模板名称">
                    <el-input v-model="queryInfo.templateName_cn" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="模板名称英文">
                    <el-input v-model="queryInfo.templateName_en" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="设计师编号"> <el-input v-model="queryInfo.designerID" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="设计师姓名"> <el-input v-model="queryInfo.designerName" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="性别(产品)"> <el-input v-model="queryInfo.zwldl" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="附加信息编码"> <el-input v-model="queryInfo.addnCode" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="产地"> <el-input v-model="queryInfo.wherl" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="状态"> <el-input v-model="queryInfo.state" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="创建人员"> <el-input v-model="queryInfo.createUserID" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="创建时间"> <el-input v-model="queryInfo.createTime" disabled style="width: 80%"></el-input> </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产品编码"> <el-input v-model="queryInfo.productCode" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="产品名称中文">
                    <el-input v-model="queryInfo.productName_CN" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="产品名称英文">
                    <el-input v-model="queryInfo.productName_EN" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="产品名称意大利">
                    <el-input v-model="queryInfo.productName_IT" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="产品描述"> <el-input v-model="queryInfo.description" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="类别编号"> <el-input v-model="queryInfo.categoryID" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="款号编号"> <el-input v-model="queryInfo.styleID" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="款号附加位编号">
                    <el-input v-model="queryInfo.styleAddnCode" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="主成份编号"> <el-input v-model="queryInfo.mainCompID" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="颜色编号"> <el-input v-model="queryInfo.colorID" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="季号"> <el-input v-model="queryInfo.seasonID" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="修改人员"> <el-input v-model="queryInfo.updateUserName" disabled style="width: 80%"></el-input> </el-form-item>
                  <el-form-item label="修改时间"> <el-input v-model="queryInfo.updateTime" disabled style="width: 80%"></el-input> </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>
      </div>
      <!-- 右侧列表相关链接 -->
      <!-- 使用封装的组件 -->
      <div class="PagesContentRight">
        <RightCard></RightCard>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { queryBySkuApi } from "@/api/viewMemberModule";
export default {
  name: "centre",
  data() {
    return {
      queryInfo: {
        sku: "",
        skudesc_CN: "",
        skudesc_EN: "",
        skudesc_IT: "",
        brandNo: "",
        familyID: "",
        category_cn: "",
        category_en: "",
        lineID: "",
        composition_cn: "",
        composition_en: "",
        sizeTemplateID: "",
        templateName_cn: "",
        templateName_en: "",
        designerID: "",
        designerName: "",
        zwldl: "",
        addnCode: "",
        wherl: "",
        state: "",
        createUserID: "",
        createTime: "",
        productCode: "",
        productName_CN: "",
        productName_EN: "",
        productName_IT: "",
        description: "",
        categoryID: "",
        styleID: "",
        styleAddnCode: "",
        mainCompID: "",
        colorID: "",
        seasonID: "",
        updateUserName: "",
        updateTime: "",
        imgFileName1: "",
      },
    };
  },
  created() {
    // 列表数据
    this.getInfo();
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
    isMore() {
      return this.judge;
    },
  },
  methods: {
    getInfo() {
      let data = require("qs").stringify({ SKU: this.$route.query.sku });
      queryBySkuApi(data).then((res) => {
        if (res.data) {
          res.data.createTime = this.renderTime(res.data.createTime).substring(0, 16);
          res.data.updateTime = this.renderTime(res.data.updateTime).substring(0, 16);
          res.data.imgFileName1 = "/img/" + res.data.imgFileName1;
          this.queryInfo = res.data;
        }
      });
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    //单据类型筛选
    saleFilter(value) {
      let result;
      switch (value) {
        case 0:
          result = "销售";
          break;
        case 1:
          result = "换货";
          break;
        case 2:
          result = "退货";
          break;
        case 3:
          result = "预购单提货";
          break;
        case 10:
          result = "预购";
          break;
        case 11:
          result = "预购撤单";
          break;
      }
      return result;
    },
    NvagetToLookMenber() {
      this.$router.push("/RecordTransactions");
    },
  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth {
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  height: 990px;
  margin-left: 25px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.NumberTable {
  margin-top: 20px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}

/deep/ .el-form-item--small.el-form-item {
  margin-bottom: 0.1rem;
}

/deep/.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 14px;
}
</style>
